const banners = document.querySelectorAll('.banner-catalog');

banners.forEach((banner) => {
  const close = banner.querySelector('.banner-catalog__close');
  if (close) {
    close.addEventListener('click', function (evt) {
      evt.preventDefault();
      banner.remove();
    });
  }
});
